module.exports = __webpack_public_path__ + "static/house-1.1dffad4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/house/house-1.png
// module id = 599
// module chunks = 263791100135453